<template lang="pug" src="./hero-home.pug"></template>

<script>
import Icon from '@/components/icon/icon'
export default {
  props: ['props'],
  data: () => ({
    imgIndex: 0,
    time: 5000
  }),
  created () {
    setInterval(() => {
      this.changeSlide('right')
    }, this.time)
  },
  computed: {
    currentImage () {
      return this.props[this.imgIndex]
    }
  },
  methods: {
    changeSlide (direction) {
      const atFirstIndex = this.imgIndex === 0
      const atLastIndex = this.imgIndex === (this.props.length - 1)
      if (direction === 'left') {
        atFirstIndex ? this.imgIndex = (this.props.length - 1) : this.imgIndex -= 1
      }
      if (direction === 'right') {
        atLastIndex ? this.imgIndex = 0 : this.imgIndex += 1
      }
    },
    jumpToSlide (index) {
      this.imgIndex = index
    }
  },
  components: { Icon }
}
</script>



// WEBPACK FOOTER //
// src/components/hero/hero-home/hero-home.vue